import { Component, Input, inject } from '@angular/core';

import { AuthService } from '../../../services/auth.service';
import { RecordService } from '../../../services/record.service';
import { ToastComponent } from '../../toast/toast.component';
import { Record } from '../../models/record.model';
import { RecordComment } from '../../types';
import { ee } from '../../constants';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-add-comment-modal',
  templateUrl: './add-comment-modal.component.html',
  standalone: false
})
export class AddCommentModalComponent {
  toast = inject(ToastComponent);
  private auth = inject(AuthService);
  private recordService = inject(RecordService);


  @Input() record: Record;

  commentText = '';

  addComment(record: Record): void {
    const comment: RecordComment = {
      id: 0, // This will be replaces in backend
      _user: this.auth.currentUser._id,
      text: this.commentText,
    };
    this.recordService.addComment(record, comment)
      .pipe(finalize(() => ee.emit('getRecord')))
      .subscribe({
        next: res => this.toast.setMessage('Comment added successfully.', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
